// extracted by mini-css-extract-plugin
module.exports = {"main-component":"decrementArrow_main-component__1rDig"};